import React from "react";
import { Tooltip as MTooltip } from "@material-ui/core";

export const Tooltip = ({
  children,
  closeDelay = 100,
  content,
  disabled = false,
  gap = 8,
  openDelay = 100,
  placement = "top",
  portal = true,
}) => {
  // Tooltip won't render anything if disabled or no content
  if (disabled || !content) {
    return <span>{children}</span>;
  }

  return (
    <MTooltip
      title={
        typeof content === "string" ? (
          <span className="text-sm text-white">{content}</span>
        ) : (
          content
        )
      }
      placement={placement}
      enterDelay={openDelay}
      leaveDelay={closeDelay}
      arrow
      disablePortal={!portal}
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, gap],
            },
          },
        ],
      }}
    >
      <span>{children}</span>
    </MTooltip>
  );
};

export default Tooltip;
